(function () {
    "use strict";

    // @ngInject
    function EmailSettingsControllerCtor($scope, $stateParams, $injector, $timeout, AnalyticsService, NetworkManager, Enums) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'EmailSettingsController';

        this.NetworkManager = NetworkManager;
        this.$timeout = $timeout;
        this.Enums = Enums;
        this.user = this.NetworkManager.getNetworkCurrUser(true);
        this.isFormDirty = false;
        this.isSavingSettings = false;
        this.isShowingNotificationSaved = false;
        this.isReady = false;
        this.unsubscribeData = {};

        AnalyticsService.track(this, AnalyticsService.analytics_events.unsubscribe_from_email_loaded);
        this.emailUnsubscribeTypes = [
            {modelKey: 'unsubscribe_network_connections', apiKey: 'connections', analyticsKey: 'connections', translationPrefix: 'NETWORK.EMAIL_SETTINGS._UNSUBSCRIBE_CONNECTIONS', display: true},
            {modelKey: 'unsubscribe_network_project_updates', apiKey: 'project_updates', analyticsKey: 'project info', translationPrefix: 'NETWORK.EMAIL_SETTINGS._UNSUBSCRIBE_PROJECTS', display: true},
            {modelKey: 'unsubscribe_network_opportunities', apiKey: 'opportunities', analyticsKey: 'opportunities', translationPrefix: 'NETWORK.EMAIL_SETTINGS._UNSUBSCRIBE_OPPORTUNITIES', display: true},
            {modelKey: 'unsubscribe_network_general_info', apiKey: 'general_info', analyticsKey: 'general info', translationPrefix: 'NETWORK.EMAIL_SETTINGS._UNSUBSCRIBE_GENERAL', display: true},
            // {modelKey: 'unsubscribe_network_opportunities_digest', apiKey: 'opportunities_digest', analyticsKey: 'opportunities digest', translationPrefix: 'NETWORK.EMAIL_SETTINGS._UNSUBSCRIBE_OPPORTUNITIES_DIGEST', display: false},
        ];

        this.emailUnsubscribeTypes.forEach(function (unsubscribeType) {
            this.unsubscribeData[unsubscribeType.apiKey] = false;
        }.bind(this));

        this.unsubcribeType = $stateParams.email_unsubscribe_type;
        this.unsubscribeEmailName = $stateParams.unsubscribe_email_name;

        this.user.on("network_user_success", function(){
            this.updateUserEmailPreferences();
            if(this.unsubcribeType && this.unsubcribeType in this.unsubscribeData){
                var data = {
                    unsubscribe_type: this.unsubcribeType,
                    email_name: this.unsubscribeEmailName
                };
                AnalyticsService.track(this, AnalyticsService.analytics_events.network_unsubscribe_from_email, data);
                this.unsubscribeData[this.unsubcribeType] = true;
                this.update();
            }
            this.$timeout(function() { this.isReady = true; }.bind(this), 1000);

        }.bind(this));
    }


    Controllers.EmailSettingsController = Class(Controllers.BaseController, {

        constructor: EmailSettingsControllerCtor,

        toggleUnsubscribe: function toggleUnsubscribe(){
            if(!this.isFormDirty){
                this.isFormDirty = true;
            }
        },

        updateUserEmailPreferences: function updateUserEmailPreferences(){
            if(this.user.user_email_container){
                this.emailUnsubscribeTypes.forEach(function (unsubscribeType) {
                    this.unsubscribeData[unsubscribeType.apiKey] = this.user.user_email_container[unsubscribeType.modelKey] === null ? false : this.user.user_email_container[unsubscribeType.modelKey];
                }.bind(this));
            }
        },

        unsubscribeAll: function unsubscribeAll(){
            Object.keys(this.unsubscribeData).forEach(function (key) {
                this.unsubscribeData[key] = true;
            }.bind(this));
            this.update();
        },

        update: function update() {
            this.isSavingSettings = true;
            this.NetworkManager.saveNetworkEmailUnsubscribes(this.user, this.unsubscribeData).then(function(){
                this.updateUserEmailPreferences();
                this.isSavingSettings = false;
                this.isShowingNotificationSaved = true;
                this.$timeout(function () {
                    this.isShowingNotificationSaved = false;
                }.bind(this), 3000);
            }.bind(this));
        }

    });
}());
